module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/gamer-1c9983cc69185e6895569b90f102f67c.png";